/**
 * @desc 从EBS获取银行信息数据
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.AppAccountRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bankInfo/refreshBankInfoByParam`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
